import { Component, OnInit,Input } from '@angular/core';
import {commonService} from "../../service/common.service";
import {ForumsService} from "../../service/forums.service";
import {HttpErrorResponse } from '@angular/common/http';
import {Globals } from '../../globals';
@Component({
  selector: 'app-userinfo',
  templateUrl: './userinfo.component.html',
  styleUrls: ['./userinfo.component.css'],
  providers:[Globals,ForumsService]
})
export class UserinfoComponent implements OnInit {
  @Input() public user;
  userInfo:any;
  userData:any;
  userLoad=false;
  constructor(private commonService:commonService,private forumsService:ForumsService,private global : Globals ) {
    
  
      this.commonService.profile.subscribe((data:any)=>{
        // console.log('after Load call sub');
         if(data){
         this.userData=data; 
        // console.log(this.userData);
         }else{
           this.userData={};
         } 
   
       });

   }

  ngOnInit() {
    
    if(this.user){
      this.userInfo=this.user;
     // console.log(this.userInfo);
      }

  }
  getImagePath(path,anonymously,width,height){
    if(!path || anonymously==1){
      path='avatar.png';
    }

 if(width!=undefined && height!=undefined){
  let res=this.global.websiteImgUrl+this.global.profileFolder+'/'+path+'&width='+width+'&height='+height;
  return res;
}else{
  let res=this.global.websiteImgUrl+this.global.profileFolder+'/'+path;
  return res;
}
  

  }

  userFollower(user){
    if(Object.keys(this.userData).length == 0){ 
      this.commonService.setLoginBox(true); 
      return false;
    } 

    let obj={}
    obj['f_userid']=(this.userData.id)?this.userData.id:0;
    obj['t_userid']=user.id;
    this.forumsService.userFollower(obj).subscribe((data:any)=>{
          if(data.error==0){
        
            if(data.result=='add'){
              if(parseInt(user.follower) == null){
                user.follower=0;
              }
              if(parseInt(user.ismyfollow) == null){
                user.ismyfollow=1;
              }
              
              user.follower = parseInt(user.follower) + 1;
              user.ismyfollow=1;
              //console.log(user);
  
            }else if(data.result=='sub'){
              if(parseInt(user.follower) == null){
                user.follower=0;
              }
              if(parseInt(user.ismyfollow) == null){
                user.ismyfollow=0;
              }
              
              user.follower = parseInt(user.follower) - 1;
              user.ismyfollow=0;
              //console.log(user);
            }
            
          }
    },(error:HttpErrorResponse)=>{
     // this.msg="internal server error!";
    })
  
  }

}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/userinfo/userinfo.component.ts